import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  justify-content: center;
  margin-left: -35px;
`;

const WeatherLogoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  width: 220px;
`;
const WeatherLogo = styled.img`
  heigth: 6rem;
  width: 6rem;
  margin-top: -1rem;
`;

const Temperature = styled.div`
  font-size: 30px;
  font-width: bold;
  display: flex;
  flex-direction: column;
  & span {
    font-size: 1rem;
    font-weight: normal;
    display: flex;
  }
`;

const CityName = styled.div`
  display: flex;
  font-size: 20px;
  font-weight: bold;
  width: 13rem;
  justify-content: center;text-align:center
  padding: 10px 0px;
  color: rgb(148, 77, 130);
`;

const WeatherInfoText = styled.div`
  font-size: 15px;
  font-weight: 400;
  display: flex;
  color: blue;
  padding-top: 10px;
`;

const WeatherInfoContainer = styled.div`
  font-size: 15px;
  font-weight: 400;
  display: flex;
  aligned-items: left;
  flex-directin: row;
  width: 3rem;
  padding: 0.3rem 0rem;
`;

const WeatherPropertyIcon = styled.img`
  heigth: 1rem;
  width: 1.5rem;
  display: flex;
`;

const InfoDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 0.5rem;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  width: 12rem;
  justify-content: space-between;
  padding: 0.8rem 0rem;
`;

const ShowWeather = (props) => {
  const iconArray = {
    Weather: "icons/weather.jpg",
    Humidity: "icons/humidity.jpg",
    Wind: "icons/wind.jpg",
    Pressure: "icons/pressure.jpg",
    Sunrise: "icons/sunrise.jpg",
    Sunset: "icons/sunset.jpg",
  };

  const getTime = (timeStamps) => {
    return `${new Date(timeStamps * 1000).getHours()} : ${new Date(
      timeStamps * 1000
    ).getMinutes()}`;
  };

  const WeatherInfo = (props) => {
    const { iconName, value } = props;
    return (
      <WeatherInfoContainer>
        <WeatherPropertyIcon src={iconArray[iconName]} />
        <InfoDiv>
          {" "}
          <div> {value} </div> <div>{iconName}</div>{" "}
        </InfoDiv>
      </WeatherInfoContainer>
    );
  };
  const { weather } = props;

  const isDay = weather?.weather[0]?.icon?.includes("d");

  return (
    <Container>
      <WeatherLogoContainer>
        <Temperature>
          {Math.floor(weather?.main?.temp - 273)}°C{" "}
          <span>{weather?.weather[0]?.description} </span>{" "}
        </Temperature>

        <WeatherLogo
          src={`http://openweathermap.org/img/wn/${weather?.weather[0]?.icon}@2x.png`}
        />
      </WeatherLogoContainer>
      <CityName>
        {weather?.name} , {weather?.sys?.country}
      </CityName>

      <WeatherInfoText>Weather Info</WeatherInfoText>
      <Row>
        <InfoDiv>
          <WeatherInfo
            iconName={isDay ? "Sunrise" : "Sunset"}
            value={getTime(weather?.sys[isDay ? "sunrise" : "sunset"])}
          />
          <WeatherInfo iconName="Humidity" value={weather?.main?.humidity} />
        </InfoDiv>
        <InfoDiv>
          <WeatherInfo iconName="Wind" value={weather?.wind?.speed} />
          <WeatherInfo iconName="Pressure" value={weather?.main?.pressure} />
        </InfoDiv>
      </Row>
    </Container>
  );
};

export default ShowWeather;
